import axios from 'axios';
import config from '../../../config';

import {getTemplates} from './../../templates/actions';

const postTemplateStart = () => {
  return {
    type: 'POST_TEMPLATE_START',
  };
};

const postTemplateSuccess = ({ data }) => {
  return {
    type: 'POST_TEMPLATE_SUCCESS',
    data,
  };
};

const postTemplateFail = () => {
  return {
    type: 'POST_TEMPLATE_FAIL',
  };
};

export function postTemplate(data) {
  return (dispatch, getState) => {
    dispatch(postTemplateStart());

    const { login } = getState();
    axios
      .post(`${config.API_URL}/template/create`, data, {
        headers: {
          Authorization: `Bearer ${login.token}`,
        },
      })
      .then((resp) => {
        dispatch(postTemplateSuccess({ data: resp.data }));
      })
      .catch((ex) => {
        console.log('Failed to save template', ex);
        dispatch(postTemplateFail());
      });
  };
}

export const resetTemplateStatus = () => {
  return (dispatch) => {
    dispatch({ type: 'RESET_TEMPLATE_STATUS', payload: false });
  };
};

// Fetch user by Id
export const getTemplateById = (templateId) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'GET_TEMPLATE_BY_ID_LOADING',
      payload: true,
    });

    const { login } = getState();
    axios
      .get(`${config.API_URL}/template/${templateId}`, {
        headers: {
          Authorization: `Bearer ${login.token}`,
        },
      })
      .then((resp) => {
        dispatch({
          type: 'GET_TEMPLATE_BY_ID',
          payload: resp.data,
        });
      })
      .catch((ex) => {
        console.log('Failed to fetch template', ex);
        dispatch({
          type: 'GET_TEMPLATE_BY_ID',
          payload: ex,
          error: true,
        });
      });
  };
};

// Update user by Id
export const updateTemplate = (templateId, data) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'UPDATE_TEMPLATE_LOADING',
      payload: true,
    });

    const { login } = getState();
    axios
      .put(`${config.API_URL}/template/${templateId}`, data, {
        headers: {
          Authorization: `Bearer ${login.token}`,
        },
      })
      .then((resp) => {
        dispatch({
          type: 'UPDATE_TEMPLATE',
          payload: resp.data,
        });
      })
      .catch((ex) => {
        console.log('Failed to update template', ex);
        dispatch({
          type: 'UPDATE_TEMPLATE',
          payload: ex,
          error: true,
        });
      });
  };
};

// Delete user by Id
export const deleteTemplate = (templateId) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'DELETE_TEMPLATE_LOADING',
      payload: true,
    });

    const { login } = getState();
    axios
      .delete(`${config.API_URL}/template/${templateId}`, {
        headers: {
          Authorization: `Bearer ${login.token}`,
        },
      })
      .then((resp) => {
        dispatch({
          type: 'DELETE_TEMPLATE',
          payload: resp.data,
        });

        dispatch(getTemplates());
      })
      .catch((ex) => {
        console.log('Failed to delete template', ex);
        dispatch({
          type: 'UPDATE_TEMPLATE',
          payload: ex,
          error: true,
        });
      });
  };
};

